import { sentryRepository } from 'repositories/SentryRepository';
import PostMessenger from './postMessenger';

export const postMessenger = new PostMessenger(sentryRepository);
